/* Package JSON Import will be here */
import React, { Component } from 'react';
import {
    Grid
} from 'semantic-ui-react';
/* Package JSON Import will be here */

class NoResultFound extends Component {

    render() {

        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column className="noresultMessages">
                        <p className="text-center text-grey ">
                            {this.props.displayMessage !== null && this.props.displayMessage}
                        </p>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default NoResultFound;

NoResultFound.displayName = 'NoResultFound';